import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Banner } from 'src/Components/banner'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.error.light,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'row',
    },
  },
}))

const UserDeletedBanner: React.FC = () => {
  const { classes } = useStyles()

  return (
    <Banner
      i18nKey="administration.users.user-deleted"
      containerStyle={classes.containerStyle}
      bannerKey={BannerKey.UserDeletedBanner}
      closeType={BannerCloseTypes.Permanent}
    />
  )
}

export default UserDeletedBanner
